import { Typography, TypographyProps, Skeleton } from '@mui/material';
import { Types } from '@scorenco/core';

import { getDateInput } from '../utils/eventGuards';

type EventDateProps = TypographyProps & {
  event?: Types.Competitions_Event_Detail;
};

export const EventDate = ({ event, ...rest }: EventDateProps) => {
  const eventDate = getDateInput(event?.date);
  const eventTime = getDateInput(event?.time);

  return (
    <Typography {...rest}>
      {[
        eventDate &&
          new Date(eventDate).toLocaleDateString([], {
            month: 'short',
            day: '2-digit',
            weekday: 'long',
            year: 'numeric',
          }),
        eventTime &&
          new Date(eventTime).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          }),
      ]
        .filter(Boolean)
        .join(' à ') || <Skeleton width={250} />}
    </Typography>
  );
};
